import React, {PureComponent} from "react";
import {Route} from "react-router-dom";
import CupoyRouterSwitchView from "components/commons/router/CupoyRouterSwitchView";
import Topbar from "./Topbar";

class MainView extends PureComponent {

    render() {

        return (

            <div id="container-wrapper">
                <Topbar/>
                <Route component={CupoyRouterSwitchView}/>
            </div>

        );
    }
}


export default MainView;



// WEBPACK FOOTER //
// ./src/components/MainView.jsx